export default class NetworkError extends Error {
  constructor(error) {
    const errorToJson = JSON.stringify(error);
    super(errorToJson);

    Object.assign(this, JSON.parse(errorToJson));
  }
}
